import { Data } from '@blade/std-lib'

import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair'

export type FavoritePairsChangedEvent =
  | FavoritePairRemovedEvent
  | FavoritePairAddedEvent

export class FavoritePairRemovedEvent extends Data.TaggedClass(
  'FavoritePairRemovedEvent',
)<{
  network: Network.Network
  pairAddress: PairAddress
}> {}
export class FavoritePairAddedEvent extends Data.TaggedClass(
  'FavoritePairAddedEvent',
)<{
  network: Network.Network
  pairAddress: PairAddress
}> {}

export const match = Data.matchFor<FavoritePairsChangedEvent>()
